import React from 'react';
import {MdTextField} from 'core/components/fields/fields';
import round = require("lodash/round");
import {createForm} from 'core/form/createForm';
import {FieldText, lovValue, lovLabel, lovParam, FormProps} from 'core/form/formUtils';
import StyledSelect from 'core/components/fields/styledSelect';
import NumberField from 'core/components/fields/numberField';
import {Validate} from 'core/form/validate';
import {NumberFormat, Min, validWarn, valid, invalid, HasLength} from 'core/form/rules';
import {optionsSearch} from "core/common/service/commonDataService";
import invoiceService from 'invoice/service/invoiceService';
import productService from 'product/productService';
import {priceValue} from 'product/productUtils';
import {InvoiceItem, Invoice, INVOICEITEMTYPE, InvoiceTemplateItem, InvoiceTemplate} from "invoice/domain/invoiceDomain";
import {action, observable} from "mobx";
import {LovItem} from "core/metamodel/mdEntity";
import {Product, Price} from "product/productDomain";
import {observer} from "mobx-react";
import securityService from "core/security/securityService";
import mdEntityService from "core/metamodel/mdEntityService";
import partyService from "party/partyService";
import Checkbox from "material-ui/Checkbox";
import FaUser = require("react-icons/lib/fa/user");
import { PARTYROLE } from '../../party/partyDomain';

let _basePrice, _unitPrice;

function ComputeBasePriceExpression({value}): any {

  console.log('ComputeBasePriceExpression value = ', value);

  if (!value) return valid();

  return mdEntityService.spelExpression(value)
    .then((value: number) => {
      _basePrice = value;
      return valid();
    }).catch((error) => {
    return invalid(error.response.data.messages[0].message);
  });
}

function ComputeUnitPriceExpression({value}): any {
  if (!value) return valid();

  return mdEntityService.spelExpression(value)
    .then((value: number) => {
      _unitPrice = value;
      return valid();
    }).catch((error) => {
      return invalid(error.response.data.messages[0].message);
    });
}

@observer
class InvoiceTemplateItemForm extends React.Component<FormProps<InvoiceTemplateItem, InvoiceTemplate>, undefined> {

  @observable $showParty: boolean;

  componentWillMount() {
    let {entities, dataObject, form} = this.props;
    dataObject.$useExpression = (!!dataObject.basePriceExpression || !!dataObject.unitPriceExpression);
  }


  private computeDerived(dataObject: InvoiceTemplateItem, rootObject: InvoiceTemplate, precision: number): void {

    dataObject.basePriceWithAdjustment = dataObject.basePrice + dataObject.adjustmentAmount;
    dataObject.invoiceAdjustmentAmount = round(dataObject.basePriceWithAdjustment * rootObject.invoiceAdjustmentKoef, precision);
    dataObject.priceWithoutVat = dataObject.basePriceWithAdjustment + dataObject.invoiceAdjustmentAmount;
    dataObject.vatAmount = round(dataObject.priceWithoutVat * dataObject.vatRate, precision);
    dataObject.itemPrice = dataObject.priceWithoutVat + dataObject.vatAmount;
  }


  @action handleUseExpressionBase = (evt) => {
    let {dataObject, rootObject, form} = this.props;
    dataObject.$useExpression = !dataObject.$useExpression;

    dataObject.basePriceExpression = '';
    form.updateFieldsPropValue(dataObject, "basePriceExpression");
    rootObject.$dirty = true;

    if (dataObject.$useExpression) {
      form.getField("basePriceExpression").handleValidation({validationResult: {valid: false, error: "Field is required"}, showValidation: false}, "MANUAL");
    } else {
      form.getField("basePriceExpression").handleValidation({validationResult: {valid: true}, showValidation: false}, "MANUAL");
    }
  };

  @action handleUseExpressionUnit = (evt) => {
    let {dataObject, rootObject, form} = this.props;
    dataObject.$useExpression = !dataObject.$useExpression;

    dataObject.unitPriceExpression = '';
    form.updateFieldsPropValue(dataObject, "unitPriceExpression");
    rootObject.$dirty = true;

    if (dataObject.$useExpression) {
      form.getField("unitPriceExpression").handleValidation({validationResult: {valid: false, error: "Field is required"}, showValidation: false}, "MANUAL");
    } else {
      form.getField("unitPriceExpression").handleValidation({validationResult: {valid: true}, showValidation: false}, "MANUAL");
    }
  };

  @action onBasePriceChange = () => {
    let {dataObject, rootObject, form} = this.props;
    console.log('onBasePriceChange ', dataObject.basePrice);
    dataObject.adjustmentAmount = round(dataObject.basePrice * dataObject.adjustmentKoef, rootObject.monetaryRounding);
    this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
    rootObject.$dirty = true;
    form.updateAllFieldsPropValue(dataObject);
  };

  @action onBasePriceExpressionSuccess = () => {
    let {dataObject, rootObject, form} = this.props;
    console.log('onBasePriceExpressionSuccess _basePrice = ', _basePrice);

    dataObject.basePrice = _basePrice;
    dataObject.adjustmentAmount = round(dataObject.basePrice * dataObject.adjustmentKoef, rootObject.monetaryRounding);
    this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
    rootObject.$dirty = true;
    form.updateAllFieldsPropValue(dataObject);
  };

  @action onUnitPriceChange = () => {
    let {dataObject, rootObject, form} = this.props;
    console.log('onUnitPriceChange ', dataObject.unitPrice);
    dataObject.basePrice = dataObject.unitPrice * dataObject.quantity;
    dataObject.adjustmentAmount = round(dataObject.basePrice * dataObject.adjustmentKoef, rootObject.monetaryRounding);
    this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
    rootObject.$dirty = true;
    form.updateAllFieldsPropValue(dataObject);
  };


  @action onUnitPriceExpressionSuccess = () => {
    let {dataObject, rootObject, form} = this.props;
    console.log('onUnitPriceExpressionSuccess _unitPrice = ', _unitPrice);

    dataObject.unitPrice = _unitPrice;
    dataObject.basePrice = dataObject.unitPrice * dataObject.quantity;
    dataObject.adjustmentAmount = round(dataObject.basePrice * dataObject.adjustmentKoef, rootObject.monetaryRounding);
    this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
    rootObject.$dirty = true;
    form.updateAllFieldsPropValue(dataObject);
  };


  @action onAdjustmentKoefChange = () => {
    let {dataObject, rootObject, form} = this.props;
    console.log('onAdjustmentKoefChange ', dataObject.adjustmentKoef);
    dataObject.adjustmentAmount = round(dataObject.adjustmentKoef * dataObject.basePrice, rootObject.monetaryRounding);
    this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
    rootObject.$dirty = true;
    form.updateAllFieldsPropValue(dataObject);
  };

  @action onAdjustmentAmountChange = () => {
    let {dataObject, rootObject, form} = this.props;
    console.log('onAdjustmentAmountChange ', dataObject.adjustmentAmount);
    dataObject.adjustmentKoef = round(dataObject.adjustmentAmount / dataObject.basePrice, rootObject.monetaryRounding);
    this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
    rootObject.$dirty = true;
    form.updateAllFieldsPropValue(dataObject);
  };

  @action onPriceWithoutVatChange = () => {
    let {dataObject, rootObject, form} = this.props;
    console.log('onPriceWithoutVatChange ', dataObject.priceWithoutVat);

    dataObject.basePriceWithAdjustment = round( dataObject.priceWithoutVat / (1 + rootObject.invoiceAdjustmentKoef), rootObject.monetaryRounding);
    dataObject.basePrice = round( dataObject.basePriceWithAdjustment / (1 + dataObject.adjustmentKoef), rootObject.monetaryRounding);
    dataObject.adjustmentAmount = dataObject.basePriceWithAdjustment - dataObject.basePrice;
    dataObject.invoiceAdjustmentAmount = dataObject.priceWithoutVat - dataObject.basePriceWithAdjustment;
    dataObject.vatAmount = round(dataObject.priceWithoutVat * dataObject.vatRate, rootObject.monetaryRounding);
    dataObject.itemPrice = dataObject.priceWithoutVat + dataObject.vatAmount;
    rootObject.$dirty = true;
    form.updateAllFieldsPropValue(dataObject);
  };

  @action onItemPriceChange = () => {
    let {dataObject, rootObject, form} = this.props;
    console.log('onItemPriceChange ', dataObject.itemPrice);
    dataObject.priceWithoutVat = round(dataObject.itemPrice / (1 + dataObject.vatRate), rootObject.monetaryRounding);
    dataObject.vatAmount = dataObject.itemPrice - dataObject.priceWithoutVat;
    dataObject.basePriceWithAdjustment = round( dataObject.priceWithoutVat / (1 + rootObject.invoiceAdjustmentKoef), rootObject.monetaryRounding);
    dataObject.basePrice = round( dataObject.basePriceWithAdjustment / (1 + dataObject.adjustmentKoef), rootObject.monetaryRounding);
    dataObject.adjustmentAmount = dataObject.basePriceWithAdjustment - dataObject.basePrice;
    dataObject.invoiceAdjustmentAmount = dataObject.priceWithoutVat - dataObject.basePriceWithAdjustment;
    rootObject.$dirty = true;
    form.updateAllFieldsPropValue(dataObject);
  };



  @action onVatRateRefChange = () => {
    let {dataObject, rootObject, form} = this.props;
    console.log('onVatRateRefChange ', dataObject.vatRateRef);

    let vatRateId = lovValue(dataObject.vatRateRef);

    return ((vatRateId != null) ? invoiceService.vatRateValue(vatRateId) : Promise.resolve(null))
      .then( action("vatRateValue-actionCb", (value: number) => {
        dataObject.vatRate = value;
        this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
        rootObject.$dirty = true;
        form.updateAllFieldsPropValue(dataObject);
      }));
  };

  @action onProductChange = () => {
    let {dataObject, rootObject, form} = this.props;
    console.log('onProductChange ', dataObject.product);
    let productId = lovValue(dataObject.product);

    if (productId == null) {
      dataObject.vatRate = null;
      this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
      rootObject.$dirty = true;
      form.updateAllFieldsPropValue(dataObject);
    } else {

      let capturedProduct: Product;



      let vatRateValuePromise: Promise<number> = productService.readProduct(productId, lovValue(securityService.currentTenant.party), lovValue(rootObject.billedTo) )
        .then(product => {
          capturedProduct = product;
          let vatRateId: number = lovValue(product.vatRate);
          return ((vatRateId != null) ? invoiceService.vatRateValue(vatRateId) : Promise.resolve(null));
        });

      let vehicleId: number = lovValue(dataObject.vehicle);
      let pricePromise: Promise<Price>;

      if (rootObject.billedTo)
        pricePromise = (vehicleId == null) ? productService.readProductPrice(productId, lovValue(rootObject.billedTo), lovValue(rootObject.invoiceCurrency))
          : productService.readProductVehiclePrice(productId, vehicleId, lovValue(rootObject.billedTo), lovValue(rootObject.invoiceCurrency));
      else
        pricePromise = null;

      return Promise.all([vatRateValuePromise, pricePromise])
        .then( action("productChange-actionCb", ([vatRateValue, price]: [number, Price]) => {
        if (capturedProduct.unitOfMeasure) dataObject.unitOfMeasure = capturedProduct.unitOfMeasure;
        dataObject.vatRateRef = capturedProduct.vatRate;
        dataObject.vatRate = vatRateValue;
        dataObject.unitPrice = priceValue(price);
        dataObject.description = capturedProduct.name;
        dataObject.productNumber = capturedProduct.productNumber;
        dataObject.taxType = capturedProduct.taxType;
        dataObject.basePrice = dataObject.unitPrice * dataObject.quantity;
        this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
        rootObject.$dirty = true;
        form.updateAllFieldsPropValue(dataObject);
      }));

    }

  };

  @action onVehicleChange = () => {
    let {dataObject, rootObject, form} = this.props;
    console.log('onVehicleChange ', dataObject.vehicle);

    let vehicleId = lovValue(dataObject.vehicle);

    let productId = lovValue(dataObject.product);

    if (vehicleId == null || productId == null || !rootObject.billedTo) {
      rootObject.$dirty = true;
      form.updateAllFieldsPropValue(dataObject);
    } else {
      return productService.readProductVehiclePrice(productId, vehicleId, lovValue(rootObject.billedTo), lovValue(rootObject.invoiceCurrency))
        .then(action("vehicleChange-actionCb", (price: Price) => {
          dataObject.unitPrice = priceValue(price);
          dataObject.basePrice = dataObject.unitPrice * dataObject.quantity;
          this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
          rootObject.$dirty = true;
          form.updateAllFieldsPropValue(dataObject);
        }));
    }
  };


  @action onQuantityChange = () => {
    let {dataObject, rootObject, form} = this.props;
    console.log('onQuantityChange ', dataObject.quantity);
    dataObject.basePrice = dataObject.unitPrice * dataObject.quantity;
    dataObject.adjustmentAmount = round(dataObject.basePrice * dataObject.adjustmentKoef, rootObject.monetaryRounding);
    this.computeDerived(dataObject, rootObject, rootObject.monetaryRounding);
    rootObject.$dirty = true;
    form.updateAllFieldsPropValue(dataObject);
  };

  @action onShowParty = () => {
    let {dataObject, rootObject, form} = this.props;
    console.log('onShowParty ', dataObject.quantity);
    this.$showParty = true;
  };



  render() {

    let {dataObject, rootObject, entities, formName} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {product, vehicle, productNumber, description, unitOfMeasure, quantity,
      unitPrice, basePrice, basePriceExpression, unitPriceExpression, adjustmentKoef,
      adjustmentAmount, priceWithoutVat, vatAmount, itemPrice, vatRate, vatRateRef, invoiceAdjustmentAmount,taxType,
      comment, party}
      = fields;

    console.debug("InvoiceTemplateItemForm#render() %O", dataObject);

    let formComp = null;

    let _showExpressionStyle = (dataObject.$useExpression) ? {} : {display: 'none'};
    let _hideExpressionStyle = (dataObject.$useExpression) ? {display: 'none'} : {};

    switch (lovValue(dataObject.itemType)) {
      case INVOICEITEMTYPE.FREEITEM:
        formComp = (
          <div>
            <div className="row">
              <div className="fx col-xs-12 col-sm-6">
                <MdTextField {...description.props} />
                <Validate field={description} value={description.props.value}/>
              </div>
              <div className="fx col-xs-8 col-sm-4">
                <StyledSelect {...vatRateRef.props}  />
                <Validate field={vatRateRef} value={vatRateRef.props.value} onSuccess={this.onVatRateRefChange}/>
                <FieldText label="" style={{alignSelf: 'flex-end', paddingBottom: 10}} value={dataObject.vatRate}  mdField={vatRate.mdField} />
              </div>
              <div className="fx col-xs-4 col-sm-2" style={{alignSelf: 'center'}}>
                <Checkbox onCheck={this.handleUseExpressionBase} label="Expression" checked={dataObject.$useExpression}
                          labelStyle={{marginLeft: -10}}/>
              </div>
              <div className="fx col-xs-6 col-sm-2" style={_showExpressionStyle}>
                <MdTextField {...basePriceExpression.props}/>
                <Validate field={basePriceExpression} dataObject={dataObject} value={basePriceExpression.props.value} onSuccess={this.onBasePriceExpressionSuccess}>
                  <ComputeBasePriceExpression/>
                </Validate>
              </div>
              <div className="fx col-xs-4 col-sm-2" style={_hideExpressionStyle}>
                <NumberField {...basePrice.props}/>
                <Validate field={basePrice} value={basePrice.props.value} onSuccess={this.onBasePriceChange}/>
              </div>
              <div className="fx col-xs-4 col-sm-1">
                <NumberField {...adjustmentKoef.props}  />
                <Validate field={adjustmentKoef} value={adjustmentKoef.props.value} onSuccess={this.onAdjustmentKoefChange}/>
              </div>
              <div className="fx col-xs-4 col-sm-2">
                <NumberField {...adjustmentAmount.props}  />
                <Validate field={adjustmentAmount} value={adjustmentAmount.props.value} onSuccess={this.onAdjustmentAmountChange}/>
              </div>

              <div className="fx col-xs-6 col-sm-2">
                <NumberField {...priceWithoutVat.props} disabled={dataObject.$useExpression}  />
                <Validate field={priceWithoutVat} value={priceWithoutVat.props.value} onSuccess={this.onPriceWithoutVatChange}/>
              </div>
              <div className="fx col-xs-6 col-sm-2">
                <NumberField {...vatAmount.props} disabled={true}/>
              </div>
              <div className="fx col-xs-6 col-sm-2">
                <NumberField {...itemPrice.props} disabled={dataObject.$useExpression} />
                <Validate field={itemPrice} value={itemPrice.props.value} onSuccess={this.onItemPriceChange}/>
              </div>
              <div className="fx col-xs-6 col-sm-3">
                <StyledSelect {...taxType.props}  />
              </div>
              <div className="fx col-xs-12 col-sm-4">
                <MdTextField {...comment.props}  />
                <Validate field={comment} value={comment.props.value} >
                  <HasLength max={150}/>
                </Validate>
              </div>
            </div>
          </div>
        );
        break;
      case INVOICEITEMTYPE.PRODUCTITEM:
        formComp = (
          <div>
            <div className="row">
              <div className="fx col-xs-8 col-sm-4">
                <StyledSelect {...product.props} async loadOptions={optionsSearch.bind(this, 'Product', {})} clearable asterixForAll/>
                <Validate field={product} value={product.props.value} onSuccess={this.onProductChange}/>
              </div>
              <div className="fx col-xs-4 col-sm-2">
                <MdTextField {...productNumber.props} />
                <Validate field={productNumber} value={productNumber.props.value}/>
              </div>
              <div className="fx col-xs-12 col-sm-6">
                <MdTextField {...description.props} />
                <Validate field={description} value={description.props.value}/>
              </div>

              <div className="fx col-xs-8 col-sm-4">
                <StyledSelect {...vatRateRef.props}  />
                <Validate field={vatRateRef} value={vatRateRef.props.value} onSuccess={this.onVatRateRefChange}/>
                <FieldText label="" style={{alignSelf: 'flex-end', paddingBottom: 10}} value={dataObject.vatRate}  mdField={vatRate.mdField} />
              </div>

              <div className="fx col-xs-4 col-sm-2" style={{position: 'relative', top: 26}}>
                <Checkbox onCheck={this.handleUseExpressionUnit} label="Expression" checked={dataObject.$useExpression}
                          labelStyle={{marginLeft: -10}}/>
              </div>
              <div className="fx col-xs-6 col-sm-2" style={_showExpressionStyle}>
                <MdTextField {...unitPriceExpression.props}/>
                <Validate field={unitPriceExpression} dataObject={dataObject} value={unitPriceExpression.props.value} onSuccess={this.onUnitPriceExpressionSuccess}>
                  <ComputeUnitPriceExpression/>
                </Validate>
              </div>

              <div className="fx col-xs-6 col-sm-2" style={_hideExpressionStyle}>
                <NumberField {...unitPrice.props}  />
                <Validate field={unitPrice} value={unitPrice.props.value} onSuccess={this.onUnitPriceChange}/>
              </div>
              <div className="fx col-xs-6 col-sm-2">
                <NumberField {...quantity.props}  />
                <Validate field={quantity} value={quantity.props.value} onSuccess={this.onQuantityChange}>
                  <NumberFormat precision={10} scale={2}/>
                </Validate>
              </div>
              <div className="fx col-xs-6 col-sm-2">
                <StyledSelect {...unitOfMeasure.props} />
                <Validate field={unitOfMeasure} value={unitOfMeasure.props.value}/>
              </div>
              <div className="fx col-xs-6 col-sm-2">
                <NumberField {...basePrice.props} disabled={true} />
              </div>
              <div className="fx col-xs-6 col-sm-2">
                <NumberField {...adjustmentKoef.props}  />
                <Validate field={adjustmentKoef} value={adjustmentKoef.props.value} onSuccess={this.onAdjustmentKoefChange}/>
              </div>
              <div className="fx col-xs-6 col-sm-2">
                <NumberField {...adjustmentAmount.props}  />
                <Validate field={adjustmentAmount} value={adjustmentAmount.props.value} onSuccess={this.onAdjustmentAmountChange}/>
              </div>

              <div className="fx col-xs-6 col-sm-3">
                <StyledSelect {...taxType.props}  />
              </div>
              <div className="fx col-xs-12 col-sm-4">
                <MdTextField {...comment.props}  />
                <Validate field={comment} value={comment.props.value} >
                  <HasLength max={150}/>
                </Validate>

                <FaUser
                  className="active-item--check zz-ml-15" style={{alignSelf: "center"}}
                  size={18}
                  onClick={this.onShowParty}
                />
              </div>

              { (!!this.$showParty || party.props.value) &&
                <div className="fx col-xs-6 col-sm-2">
                  <StyledSelect {...party.props} async loadOptions={optionsSearch.bind(this, 'Party', {role: [PARTYROLE.EMPLOYEE]})} clearable asterixForAll/>
                </div>
              }

            </div>
            <div className="row">
              <div className="fx col-xs-12" style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
                {(dataObject.invoiceAdjustmentAmount) ?
                  <FieldText label={invoiceAdjustmentAmount.textLabel} value={dataObject.invoiceAdjustmentAmount}
                             mdField={invoiceAdjustmentAmount.mdField}/> : null}
                <FieldText label={priceWithoutVat.textLabel} value={dataObject.priceWithoutVat}
                           mdField={priceWithoutVat.mdField}/>
                <FieldText label={vatAmount.textLabel} value={dataObject.vatAmount} mdField={vatAmount.mdField}/>
                <FieldText label={itemPrice.textLabel} value={dataObject.itemPrice} mdField={itemPrice.mdField}/>
              </div>
            </div>
          </div>
        );
        break;
      case INVOICEITEMTYPE.PRODUCTVEHICLEITEM:
        let billedToId = lovValue(rootObject.billedTo);
        formComp = (
          <div>
            <div className="row">
              <div className="fx col-xs-8 col-sm-4">
                <StyledSelect {...product.props} async loadOptions={optionsSearch.bind(this, 'Product', {})} clearable asterixForAll/>
                <Validate field={product} value={product.props.value} onSuccess={this.onProductChange}/>
              </div>
              <div className="fx col-xs-4 col-sm-4">
                <MdTextField {...productNumber.props} />
                <Validate field={productNumber} value={productNumber.props.value}/>
              </div>
              <div className="fx col-xs-12 col-sm-4">
                <StyledSelect {...vehicle.props}  minimumInput={0} asterixForAll={true}
                                                 async={true} loadOptions={optionsSearch.bind(this, 'Vehicle', {partyId: billedToId})} advancedSearchGL="invoiceItemVehicleSearch" advancedSearchMasterId={billedToId} />
                <Validate field={vehicle} value={vehicle.props.value} onSuccess={this.onVehicleChange}/>
              </div>
              <div className="fx col-xs-12 col-sm-4">
                <MdTextField {...description.props} />
                <Validate field={description} value={description.props.value}/>
              </div>

              <div className="fx col-xs-8 col-sm-4">
                <StyledSelect {...vatRateRef.props}  />
                <Validate field={vatRateRef} value={vatRateRef.props.value} onSuccess={this.onVatRateRefChange}/>
                <FieldText label="" style={{alignSelf: 'flex-end', paddingBottom: 10}} value={dataObject.vatRate}  mdField={vatRate.mdField} />
              </div>

              <div className="fx col-xs-4 col-sm-1" style={{position: 'relative', top: 26}}>
                <Checkbox onCheck={this.handleUseExpressionUnit} label="Expression" checked={dataObject.$useExpression}
                          labelStyle={{marginLeft: -10}}/>
              </div>
              <div className="fx col-xs-6 col-sm-2" style={_showExpressionStyle}>
                <MdTextField {...unitPriceExpression.props}/>
                <Validate field={unitPriceExpression} dataObject={dataObject} value={unitPriceExpression.props.value} onSuccess={this.onUnitPriceExpressionSuccess}>
                  <ComputeUnitPriceExpression/>
                </Validate>
              </div>


              <div className="fx col-xs-6 col-sm-2" style={_hideExpressionStyle}>
                <NumberField {...unitPrice.props}  />
                <Validate field={unitPrice} value={unitPrice.props.value} onSuccess={this.onUnitPriceChange}/>
              </div>
              <div className="fx col-xs-6 col-sm-2">
                <NumberField {...quantity.props}  />
                <Validate field={quantity} value={quantity.props.value} onSuccess={this.onQuantityChange}>
                  <NumberFormat precision={8} scale={0}/>
                </Validate>
              </div>
              <div className="fx col-xs-6 col-sm-2">
                <StyledSelect {...unitOfMeasure.props} />
                <Validate field={unitOfMeasure} value={unitOfMeasure.props.value}/>
              </div>
              <div className="fx col-xs-6 col-sm-2">
                <NumberField {...basePrice.props} disabled={true} />
              </div>
              <div className="fx col-xs-6 col-sm-2">
                <NumberField {...adjustmentKoef.props}  />
                <Validate field={adjustmentKoef} value={adjustmentKoef.props.value} onSuccess={this.onAdjustmentKoefChange}/>
              </div>
              <div className="fx col-xs-6 col-sm-2">
                <NumberField {...adjustmentAmount.props}  />
                <Validate field={adjustmentAmount} value={adjustmentAmount.props.value} onSuccess={this.onAdjustmentAmountChange}/>
              </div>

              <div className="fx col-xs-6 col-sm-3">
                <StyledSelect {...taxType.props}  />
              </div>
              <div className="fx col-xs-12 col-sm-4">
                <MdTextField {...comment.props}  />
                <Validate field={comment} value={comment.props.value} >
                  <HasLength max={150}/>
                </Validate>
              </div>
            </div>
            <div className="row">
              <div className="fx col-xs-12" style={{display:'flex', alignItems:'center', flexWrap:'wrap'}}>
                {(dataObject.invoiceAdjustmentAmount) ? <FieldText label={invoiceAdjustmentAmount.textLabel} value={dataObject.invoiceAdjustmentAmount} mdField={invoiceAdjustmentAmount.mdField} /> : null}
                <FieldText label={priceWithoutVat.textLabel} value={dataObject.priceWithoutVat} mdField={priceWithoutVat.mdField} />
                <FieldText label={vatAmount.textLabel} value={dataObject.vatAmount}  mdField={vatAmount.mdField}/>
                <FieldText label={itemPrice.textLabel} value={dataObject.itemPrice}  mdField={itemPrice.mdField}/>
              </div>
            </div>
          </div>
        );
        break;
    }

    return formComp;
  }
}

const ClosedContent = ({dataObject, entity, entities, setDataAction, fields}) => (
  <div>
    <div className="form-text-row">
      <FieldText label={fields.product.textLabel} value={dataObject.product} />
      <FieldText label={fields.productNumber.textLabel} value={dataObject.productNumber} />
      <FieldText label={fields.vehicle.textLabel} value={dataObject.vehicle} />
    </div>

    <div className="form-text-row">
      <FieldText label={fields.description.textLabel} value={dataObject.description} />
    </div>

    <div className="form-text-row">
      <FieldText label={fields.unitPrice.textLabel} value={dataObject.unitPrice}  mdField={fields.unitPrice.mdField} />
      <FieldText label={fields.quantity.textLabel} value={dataObject.quantity}  mdField={fields.quantity.mdField} />
      <FieldText label={fields.unitOfMeasure.textLabel} value={dataObject.unitOfMeasure} />
      <FieldText label={fields.basePrice.textLabel} value={dataObject.basePrice}  mdField={fields.basePrice.mdField} />
      <FieldText label={fields.adjustmentKoef.textLabel} value={dataObject.adjustmentKoef}  mdField={fields.adjustmentKoef.mdField} />
      <FieldText label={fields.adjustmentAmount.textLabel} value={dataObject.adjustmentAmount}  mdField={fields.adjustmentAmount.mdField} />
    </div>

    <div className="form-text-row">
      <FieldText label={fields.vatRateRef.textLabel} value={dataObject.vatRateRef} />
      <FieldText label={fields.vatRate.textLabel} value={dataObject.vatRate}  mdField={fields.vatRate.mdField} />
      <FieldText label={fields.priceWithoutVat.textLabel} value={dataObject.priceWithoutVat}  mdField={fields.priceWithoutVat.mdField} />
      <FieldText label={fields.vatAmount.textLabel} value={dataObject.vatAmount}  mdField={fields.vatAmount.mdField} />
      <FieldText label={fields.itemPrice.textLabel} value={dataObject.itemPrice}  mdField={fields.itemPrice.mdField} />
    </div>
  </div>
);

const definition = {
  formName: 'InvoiceTemplateItemForm',
  fields: [{
    name: 'product',
    validators: ['IsRequired']
  }, {
    name: 'vehicle',
    validators: ['IsRequired']
  }, {
    name: 'productNumber',
    validators: ['IsRequired']
  }, {
    name: 'description',
    validators: ['IsRequired']
  }, {
    name: 'unitOfMeasure',
    validators: ['IsRequired']
  }, {
    name: 'quantity',
    validators: ['IsNumber', 'IsRequired']
  }, {
    name: 'unitPrice',
    validators: ['IsNumber', 'IsRequired']
  }, {
    name: 'basePrice',
    validators: ['IsRequired', 'IsNumber']
  }, {
    name: 'adjustmentKoef',
    validators: ['IsRequired', 'IsNumber'],
    numberFormat: '0[.][00000000]%'
  }, {
    name: 'adjustmentAmount',
    validators: ['IsRequired', 'IsNumber']
  }, {
    name: 'vatRateRef',
    validators: ['IsRequired']
  }, {
    name: 'priceWithoutVat',
    validators: ['IsRequired']
  }, {
    name: 'vatAmount',
    validators: ['IsRequired']
  }, {
    name: 'itemPrice',
    validators: ['IsRequired']
  }, {
    name: 'vatRate'
  }, {
    name: 'invoiceAdjustmentAmount'
  }, {
    name: 'unitPriceExpression',
    validators: [{validation: 'IsRequired', qualifyExpr: 'that.$useExpression'}]
  }, {
    name: 'basePriceExpression',
    validators: [{validation: 'IsRequired', qualifyExpr: 'that.$useExpression'}]
  }, {
    name: 'comment'
  }, {
    name: 'taxType'
  }, {
    name: 'party'
  }]
};


export default createForm(definition, ClosedContent)(InvoiceTemplateItemForm);






// WEBPACK FOOTER //
// ./src/invoice/component/invoiceTemplateItemForm.tsx